import React from "react";
import LegalLayout from "../../components/legal/LegalLayout";
import LegalTableOfContents from "../../components/legal/LegalTableOfContents";
import {
  communityGuidelinesSections,
  LEGAL_LAST_UPDATED,
} from "../../data/legalContent";
import LegalSectionContent from "./LegalSectionContent";

export default function CommunityGuidelinesPage() {
  return (
    <LegalLayout
      title="Community Guidelines"
      lastUpdated={LEGAL_LAST_UPDATED}
    >
      <LegalTableOfContents sections={communityGuidelinesSections} />
      {communityGuidelinesSections.map((section) => (
        <LegalSectionContent key={section.id} section={section} />
      ))}
    </LegalLayout>
  );
}
